import { Flex, IconButton, Text, Tooltip } from "@chakra-ui/react";

type LayerButtonProps = {
  label: string;
  icon: JSX.Element;
  isSelected: boolean;
  onClick: () => void;
};

export const LayerButton = ({
  label,
  icon,
  isSelected,
  onClick,
}: LayerButtonProps) => (
  <Flex direction="column" align="center" w="80px" h="70px" textAlign="center">
    <IconButton
      variant={isSelected ? "" : "outline"}
      bg={isSelected ? "newBlue.500" : "#e1f0f8"}
      color={isSelected ? "#fff" : "#0884cc"}
      _hover={{
        bg: isSelected ? "rgb(72, 132, 175)" : "#d0e7f3",
        border: "1px solid #0884cc",
      }}
      onClick={onClick}
      icon={icon}
      aria-label={label}
      mb={1}
    />
    <Tooltip label={label} hasArrow>
      <Text
        fontSize="12px"
        fontWeight="light"
        whiteSpace="normal"
        lineHeight="short"
        textOverflow="ellipsis"
        noOfLines={2}
      >
        {label}
      </Text>
    </Tooltip>
  </Flex>
);
